import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStatusMap } from "../../config/applicationStatusConfig";

const NodalPendingApplications = () => {
  const excludedStatuses = ["draft", "paymentDone"];

  const statuses = Object.entries(applicationStatusMap)
    .filter(([key]) => !excludedStatuses.includes(key))
    .map(([, value]) => value.value);

  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="Nodal Pending Applications"
        status={statuses}
        stage={["null"]}
      />
    </DashboardLayout>
  );
};

export default NodalPendingApplications;
